var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12.893,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#5F4DBC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 19.25,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#5F4DBC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 25.607,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#5F4DBC"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTEiIHk9IjEyLjg5MjgiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxLjUiIHJ4PSIwLjc1IiBmaWxsPSIjNUY0REJDIi8+CjxyZWN0IHg9IjExIiB5PSIxOS4yNSIgd2lkdGg9IjE4IiBoZWlnaHQ9IjEuNSIgcng9IjAuNzUiIGZpbGw9IiM1RjREQkMiLz4KPHJlY3QgeD0iMTEiIHk9IjI1LjYwNzIiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxLjUiIHJ4PSIwLjc1IiBmaWxsPSIjNUY0REJDIi8+Cjwvc3ZnPgo=";
export { SvgMenu as ReactComponent };